import { makeStyles, Theme } from '@material-ui/core/styles';
import { indigo } from '@material-ui/core/colors';

const useStyles = makeStyles((theme: Theme) => ({
  '@global': {
    '.block-picker': {
      boxShadow: 'none !important',
      borderRadius: '0 !important',
    },
    '.block-picker > div': {
      borderRadius: '0 !important',
    },
  },
  root: {
    flexGrow: 1,
    minWidth: 895,
  },
  table: {
    minWidth: 650,
  },
  infoTextField: {
    width: '100%',
    paddingBottom: theme.spacing(3.8),
  },
  titleEmphasize: {
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  createAutomatedCollectionWrap: {
    width: '960px',
  },
  verticalGrid: {},
  contentSettingWrap: {
    marginBottom: theme.spacing(3),
    marginRight: theme.spacing(3),
    padding: theme.spacing(3),
  },
  sectionTitle: {
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  flexSectionTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  chip: {
    marginLeft: theme.spacing(1.5),
  },
  colorPicker: {
    border: '1px solid #e8e8e8',
  },
  radioButtonGroups: {
    flexDirection: 'row',
    '& > label': {
      flex: '1',
    },
    marginBottom: theme.spacing(3),
  },
  datePicker: {
    width: 220,
    marginBottom: theme.spacing(3),
  },

  formControl: {
    margin: theme.spacing(1),
    minWidth: 96,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  queryTextArea: {
    width: '100%',
    fontSize: '0.75rem',
    letterSpacing: '-0.1px',
    padding: theme.spacing(1),
    borderColor: '#e8e8e8',
    marginBottom: theme.spacing(1.2),
    fontFamily: 'Roboto Mono',
  },
  queryButton: {
    width: '100px',
  },
  testResultImage: {
    width: '45px',
    height: '80px',
    objectFit: 'cover',
    backgroundColor: '#e8e8e8',
    marginRight: theme.spacing(2),
  },
  testResultWriter: {
    color: theme.palette.text.hint,
  },
  testResultStoryId: {
    marginTop: theme.spacing(1.2),
    marginBottom: theme.spacing(),
  },

  testResultDescription: {
    marginLeft: theme.spacing(1),
  },
  testResultDescriptionError: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    color: theme.palette.error.main,
  },

  nextFireTitle: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  mainButton: {
    marginRight: theme.spacing(1),
  },
  testButtonProgress: {
    color: indigo[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },

  tableRow: {
    height: 64,
    cursor: 'pointer',
  },
  addStoriesWrap: {
    display: 'block',
    textAlign: 'right',
    marginBottom: '12px',
  },
  displayTypeForm: {
    width: '100px',
    marginBottom: '26px',
    marginTop: '22px !important',
    '&.double': {
      width: '200px',
    },
  },
  liveCollectionRow: {
    cursor: 'pointer',
    height: 63,
  },
  viewInfoItem: {
    fontSize: 14,
    color: '#888',
    paddingBottom: 30,
  },
  linkedWrap: {
    marginLeft: 16,
    height: 256,
  },
  linkedItemBox: {
    height: 134,
    border: 'solid 1px #dcdcdc',
    overflow: 'scroll',
  },
  linkedDetailItem: {
    marginBottom: 25,
  },
  noDataBox: {
    height: '200px',
  },
  inputLabel: {
    fontSize: 15,
    transform: 'scale(1)',
    color: '#212121',
    whiteSpace: 'nowrap',
  },
  tfInput: {
    paddingTop: 10,
  },
  imageFileName: {
    fontSize: 12,
    paddingTop: 10,
    color: '#999999',
  },
  paper: {
    padding: theme.spacing(3),
  },
  featuredCardSetRow: {
    cursor: 'pointer',
    height: 63,
  },

  internalTitle: {
    fontWeight: 500,
    color: theme.palette.primary.main,
    whiteSpace: 'nowrap',
    maxWidth: 150,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  featuredTitle: {
    whiteSpace: 'nowrap',
    maxWidth: 150,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  bottomButtons: {
    width: '100%',
    flex: 1,
    justifyContent: 'flex-end',
  },
  searchWrap: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  searchTextField: {
    width: '280px',
    marginBottom: '16px',
  },
  listTop: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  optionsContainer: {
    fontSize: 15,
  },
  optionsRadioButtonGroups: {
    display: 'block',
    '& > label': {
      flex: '1',
      fontSize: 15,
    },
  },
}));

export default useStyles;
